import React, {BaseSyntheticEvent, Fragment, useEffect, useState} from "react";
import {Checkbox, DialogTitle, FormControlLabel, ListItem, List, Radio} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {v4} from "uuid";
import CasinoIcon from "@mui/icons-material/Casino";
import {rollerClose, rollerRoll, rollerSetKarma, rollerSetRoll, rollerSubscriber} from "../_helper/rollBehave";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import ccAttribute from "../_helper/ccAttribute";
import {IRoller} from "../_interfaces/IRoller";
import {getDie} from "../_helper/dice";
import {s_char} from "../_signals/s_char";
import updChar from "../_sig_api/updChar";
import Grid from "@mui/material/Grid";
import {ResultsAdd} from "../_api/BEResult";
import {ModsSourceAdd} from "../_api/BEMods";
import {IniAdd} from "../_api/BEIni";
import {IIni} from "../_interfaces/IIni";
import {IResult} from "../_interfaces/IResult";
import {s_chars} from "../_signals/s_chars";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {s_app_cid, s_app_mobile, s_app_rid, s_app_sl} from "../_signals/s_app";
import {IChar} from "../_interfaces/IChar";
import {modSum} from "../_signals/s_char_calc";

const Item = styled("div")(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2,
    padding: 4,
    textAlign: 'left',
    color: '#000',
}));


export default function DialogRoller() {

    const mod_31 = [...Array(31).keys()];

    const dateOptions = {year: 'numeric', month: '2-digit', day: '2-digit'} as const;

    const [roller, setRoller] = useState<IRoller>({
        rolled: false,
        open: false,
        roll: {
            attribute: '',
            canusekarma: false,
            karma: false,
            step_mod: 0,
            step: 0,
            strain: 0,
            title: '',
            vs: 0,
            as: '',
            target: [],
            targetVS: '',
            as_fix: false
        },
        result: {
            time: 0,
            result: 0,
            rolled: '',
            step: 0,
            step_mod: 0,
            karma: '',
            successes: 0,
            success: false,
            vs: 0,
            as: ''
        }
    })

    // kv,sv,mv
    const [vs, setvs] = useState('')

    // 's' selbst
    // 'z' einzelnes Ziel
    // 'e' einzelne Ziele
    // 'g' höchste {vs} der Ziele</MenuItem>
    // 'g+' höchste {vs} der Ziele +1 für jeden
    const [vstarget, setvstarget] = useState('')

    // ziele bei vstarget z, e,g,g+
    const [targets, setTargets] = useState<string[]>([])

    const [targetOpen, setTargetOpen] = useState<boolean>(false)

    useEffect(() => {
        rollerSubscriber.subscribe(roller => {
            setRoller(roller)
            setvs(roller.roll.targetVS)
        })
    }, [])


    const displayResult = () => {
        const date = new Date(roller.result.time);
        const time = date.toLocaleTimeString('de-DE', dateOptions);
        const die = getDie(roller.result.step + roller.result.step_mod);
        return <Paper style={{marginTop: 10, padding: 8}}>
            {time ? <Item>{time}</Item> : roller.result.time}
            <Item>Stufe: {roller.result.step + roller.result.step_mod} {s_char.value.wunden > 0 ?
                <span>( - {s_char.value.wunden} Wunden)</span> : null}</Item>
            <Item>Ergebnis: {roller.result.result}
                {roller.roll.as === 'ep' && s_char.value.wunden > 0 ?
                    <span> - {s_char.value.wunden} Wunden = {roller.result.result - s_char.value.wunden}</span> : null}
            </Item>

            {roller.roll.vs ?
                <Item>
                    <div>{roller.result.success ? 'Erfolg' : 'kein Erfolg'}
                        {roller.result.successes > 0 ? ' zusätzliche Erfolge ' + roller.result.successes : null}</div>
                </Item>
                : null
            }

            <Item>Würfel: {die.d6}d6{die.mod !== 0 ? die.mod < 0 ? '' : '+' : null} {die.mod}</Item>
            <Item>gewürfelt: {roller.result.rolled}</Item>
        </Paper>
    }

    // vs
    // - kv,mv,sv
    // vstarget
    // - 's' selbst
    // - 'z' einzelnes Ziel
    // - 'e' einzelne Ziele
    // - 'g' höchste {vs} der Ziele</MenuItem>
    // - 'g+' höchste {vs} der Ziele +1 für jeden
    const getRollVS = () => {
        if (!vs) return 0;
        if (vstarget === 's') {
            if (vs === 'kv') return s_char.value.kv + modSum(s_char.value.id, 'sv')
            if (vs === 'mv') return s_char.value.mv + modSum(s_char.value.id, 'sv')
            if (vs === 'sv') return s_char.value.sv + modSum(s_char.value.id, 'sv')
        }

        const rollTargets = getRollTarget();

        let rollvs = 0;
        rollTargets.forEach(t => {
            if (vs === 'kv') {
                const kv = (s_chars.value.get(t)?.kv ?? 0) + modSum(t, 'kv')
                if (['g', 'g+'].includes(vstarget) && kv > rollvs) rollvs = kv;
            }
            if (vs === 'mv') {
                const mv = (s_chars.value.get(t)?.mv ?? 0) + modSum(t, 'mv')
                if (['g', 'g+'].includes(vstarget) && mv > rollvs) rollvs = mv;
            }
            if (vs === 'sv') {
                const sv = (s_chars.value.get(t)?.sv ?? 0) + modSum(t, 'sv')
                if (['g', 'g+'].includes(vstarget) && sv > rollvs) rollvs = sv;
            }
        })
        if (['g+'].includes(vstarget)) {
            const add = rollTargets.length > 1 ? rollTargets.length - 1 : 0;
            rollvs = rollvs + add;
        }
        return rollvs;
    }

    const getRollTarget = () => {
        if (['z','e', 'g', 'g+'].includes(vstarget)) return targets;
        if (['s'].includes(vstarget)) return [s_char.value.id];
        return []
    }

    const roll = (karma: boolean) => {

        console.log('roller roll()', roller)

        const rollvs = getRollVS()

        let roll = roller.roll;
        roll.vs = rollvs;
        roll.target = getRollTarget()

        rollerSetRoll(roll, true);
        rollerSetKarma(karma);

        let rolledResult = rollerRoll();

        if (rolledResult.rollas === 'ini') {
            const ini: IIni = {
                id: v4(),
                rid: s_app_rid.value,
                cid: s_char.value.id,
                name: s_char.value.name,
                nsc: s_char.value.nsc,
                result: rolledResult.result,
                wait: false,
                current: false
            }
            IniAdd(ini)
        }

        if (rolledResult.rollas === 'nsp' && !rolledResult.success) {
            ModsSourceAdd(s_app_cid.value, 'state_niederschlag', '');
        }

        if (rolledResult.rollas === 'ep') {

            if (rolledResult.step > 0) { // normale erholungsprobe? dann verwendete erhöhen
                updChar([{k: 'ep_used', v: s_char.value.ep_used + 1}]);
            }

            const wounds = s_char.value.wunden;
            const schaden = s_char.value.schaden;

            const remDmg = rolledResult.result;

            if (remDmg - wounds > 0) {

                const heilt = remDmg - wounds;
                let newDmg = schaden - heilt;

                updChar([{k: 'schaden', v: newDmg}]);


                let result: IResult = {
                    id: v4(),
                    cid: s_char.value.id,
                    rid: s_app_rid.value,
                    title: 'heilt ' + heilt + '(' + remDmg + ' - ' + wounds + ') Schaden',
                    name: s_char.value.name,
                    sl: s_app_sl.value,
                    nsc: s_char.value.nsc,
                    eff: '',
                    addEff: '',
                    time: 0,
                    step: 0,
                    step_mod: 0,
                    result: 0,
                    rolled: '',
                    success: false,
                    successes: 0,
                    karma: '',
                    rollas: '',
                    rollvs: 0

                };
                ResultsAdd(result);
            }
        }
    }

    const toggleAs = (as: string, e: BaseSyntheticEvent) => {
        const set = e.target.checked ? as : '';
        setRoller({
            ...roller,
            roll: {...roller.roll, as: set}
        })
    }

    const available = (char: IChar) => {
        if (s_app_sl.value || !char.nsc) return true
        return char.nsc && char.visible;
    }

    const handleSingleTarget = (id: string) => {
        const currentIndex = targets.indexOf(id);
        let newTargets: string[] = [];

        if (currentIndex === -1) {
            newTargets.push(id);
        } else {
            newTargets = [];
        }

        setTargets(newTargets);
    }

    const chooseSingleTarget = () => {
        return <List dense={true} sx={{width: '100%', bgcolor: 'background.paper'}}>
            {Array.from(s_chars.value.entries()).map(([, char]) => {
                if (!available(char)) return null
                const labelId = `checkbox-list-label-${char.id}`;
                return (
                    <ListItem key={'liid' + char.id}
                              style={{width: "100%"}}
                    >
                        <ListItemButton role={undefined} onClick={() => handleSingleTarget(char.id)} dense>
                            <ListItemIcon>
                                <Radio
                                    checked={targets.includes(char.id)}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={char.name}/>
                        </ListItemButton>
                    </ListItem>
                )
            })}
        </List>
    }

    const handleMultipleTarget = (id: string) => {
        const currentIndex = targets.indexOf(id);
        const newTargets = [...targets];

        if (currentIndex === -1) {
            newTargets.push(id);
        } else {
            newTargets.splice(currentIndex, 1);
        }

        setTargets(newTargets);
    }

    const chooseMultipleTarget = () => {
        return <List dense={true} sx={{width: '100%', bgcolor: 'background.paper'}}>
            {Array.from(s_chars.value.entries()).map(([, char]) => {
                if (!available(char)) return null
                const labelId = `checkbox-list-label-${char.id}`;
                return (
                    <ListItem key={'liid' + char.id}
                              style={{width: "100%"}}
                    >
                        <ListItemButton role={undefined} onClick={() => handleMultipleTarget(char.id)} dense>
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={targets.includes(char.id)}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{'aria-labelledby': labelId}}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={char.name}/>
                        </ListItemButton>
                    </ListItem>
                )
            })}
        </List>
    }


    return <Dialog open={roller.open} fullScreen={s_app_mobile.value} fullWidth={true} maxWidth={'xl'}>
        <DialogTitle>{roller.rolled ? 'Gewürfelt' : 'Würfeln'}</DialogTitle>
        <DialogContent style={{position: 'relative'}}>
            {targetOpen ? <Paper
                style={{padding: '20px 24px', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, zIndex: 100}}>
                {vstarget === 'z' ? chooseSingleTarget() : null}
                {['e', 'g', 'g+'].includes(vstarget) ? chooseMultipleTarget() : null}
            </Paper> : null}

            <Paper style={{padding: 8}}>
                <Item>{roller.roll.title}</Item>
                <Item>Stufe {roller.roll.step}</Item>
                <Item>Attribut {ccAttribute(roller.roll.attribute, 'tt')}</Item>
                {roller.roll.vs ? <Item>vs {roller.roll.vs}</Item> : null}
                {roller.roll.strain ? <Item>Überanstrengung {roller.roll.strain}</Item> : null}
                <Grid container>
                    <Grid item xs={2} md={3}>
                        <Item>Modifikator</Item>
                        <Item>
                            <Select value={roller.roll.step_mod || 0}
                                    style={{}}
                                    onChange={(e) => setRoller({
                                        ...roller, roll: {...roller.roll, step_mod: e.target.value as number}
                                    })}
                                    variant="standard"
                            >
                                {mod_31.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                            </Select>
                        </Item>
                    </Grid>
                    {roller.rolled && !roller.roll.as_fix ?
                        <Grid item xs={10} md={3}>
                            {roller.roll.as === 'ini' ? <Item>als Intiative </Item> : null}
                            {roller.roll.as === 'ep' ? <Item>als Erholungsprobe </Item> : null}
                            {roller.roll.as === 'nsp' ? <Item>als Niederschlagsprobe </Item> : null}
                            {roller.roll.as === 'hit' ? <Item>als Trefferwurf </Item> : null}
                            {roller.roll.as === 'dmg' ? <Item>als Schadenswurf </Item> : null}
                        </Grid> : null}
                    {!roller.rolled && !roller.roll.as_fix ?
                        <Grid item xs={10} md={9}>
                            <Grid container>
                                <Grid item xs={6} md={2}>
                                    <Item>
                                        <FormControlLabel style={{marginLeft: 0}}
                                                          label="Inititive?"
                                                          control={
                                                              <Checkbox
                                                                  checked={roller.roll.as === 'ini' || false}
                                                                  onClick={(e) => toggleAs('ini', e)}
                                                              />
                                                          }
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={6} md={2}>
                                    <Item>
                                        <FormControlLabel style={{marginLeft: 0}}
                                                          label="Erholungsprobe?"
                                                          control={
                                                              <Checkbox
                                                                  checked={roller.roll.as === 'ep' || false}
                                                                  onClick={(e) => toggleAs('ep', e)}
                                                              />
                                                          }
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={6} md={2}>
                                    <Item>
                                        <FormControlLabel
                                            style={{marginLeft: 0}}
                                            label="Schadenswurf?"
                                            control={
                                                <Checkbox
                                                    checked={roller.roll.as === 'dmg' || false}
                                                    onClick={(e) => toggleAs('dmg', e)}
                                                />
                                            }
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={6} md={2}>
                                    <Item>
                                        <FormControlLabel style={{marginLeft: 0}}
                                                          label="Niederschlagsprobe?"
                                                          control={
                                                              <Checkbox
                                                                  checked={roller.roll.as === 'nsp' || false}
                                                                  onClick={(e) => toggleAs('nsp', e)}
                                                              />
                                                          }
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={6} md={2}>
                                    <Item>
                                        <FormControlLabel
                                            style={{marginLeft: 0}}
                                            label="Trefferwurf?"
                                            control={
                                                <Checkbox
                                                    checked={roller.roll.as === 'hit' || false}
                                                    onClick={(e) => toggleAs('hit', e)}
                                                />
                                            }
                                        />
                                    </Item>
                                </Grid>
                                {['nsp'].includes(roller.roll.as) ? <Grid item xs={6} md={5}>
                                    <Item>Mindestwurf</Item>
                                    <Item>
                                        <Select value={roller.roll.vs}
                                                style={{width: "100%"}}
                                                onChange={(e) => setRoller({
                                                    ...roller, roll: {...roller.roll, vs: e.target.value as number}
                                                })}
                                                variant="standard"
                                        >
                                            {mod_31.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                                        </Select>
                                    </Item>
                                </Grid> : null}
                                {roller.roll.as === 'hit' ?
                                    <Grid container>
                                        <Grid item xs={6} md={3}>
                                            <Item>Mindestwurf</Item>
                                            <Item>
                                                <Select value={vs}
                                                        style={{width: "100%"}}
                                                        onChange={(e) => setvs(e.target.value)}
                                                        variant="standard"
                                                >
                                                    <MenuItem key={v4()} value={''}>-</MenuItem>
                                                    <MenuItem key={v4()} value={'kv'}>KV</MenuItem>
                                                    <MenuItem key={v4()} value={'mv'}>MV</MenuItem>
                                                    <MenuItem key={v4()} value={'sv'}>SV</MenuItem>
                                                </Select>
                                            </Item>
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            {vs ? <Fragment>
                                                <Item>Ziel/e</Item>
                                                <Item>
                                                    <Select value={vstarget}
                                                            style={{width: "100%"}}
                                                            onChange={(e) => setvstarget(e.target.value)}
                                                            variant="standard"
                                                    >
                                                        <MenuItem key={v4()} value={''}>-</MenuItem>
                                                        <MenuItem key={v4()} value={'s'}>selbst</MenuItem>
                                                        <MenuItem key={v4()} value={'z'}>einzelnes Ziel</MenuItem>
                                                        <MenuItem key={v4()} value={'e'}>einzelne Ziele</MenuItem>
                                                        <MenuItem key={v4()} value={'g'}>höchste {vs} der
                                                            Ziele</MenuItem>
                                                        <MenuItem key={v4()} value={'g+'}>höchste {vs} der Ziele +1 für
                                                            jedes
                                                            zusätzliche Ziel</MenuItem>
                                                    </Select>
                                                </Item>
                                            </Fragment> : null}
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            {vs && ['z', 'e', 'g', 'g+'].includes(vstarget) ? <Item>
                                                <Button onClick={() => setTargetOpen(true)}>auswählen</Button>
                                            </Item> : null}
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            {Array.from(s_chars.value.entries()).map(([, char]) => {
                                                if (targets.includes(char.id))
                                                    return (
                                                        <Item>{char.name}</Item>
                                                    )
                                                else return null
                                            })}
                                        </Grid>
                                    </Grid> : null}
                            </Grid>
                        </Grid>
                        : null
                    }
                </Grid>
            </Paper>
            {roller.rolled ? displayResult() : null}
        </DialogContent>
        <DialogActions>
            {!targetOpen && !roller.rolled && (roller.roll.step > 0 || roller.roll.step_mod > 0) ? <Fragment>
                <CasinoIcon onClick={() => roll(false)}/>

                {roller.roll.canusekarma ? <CasinoIcon style={{color: 'red'}} onClick={() => roll(true)}/> : null}
            </Fragment> : null}

            {targetOpen ? <Button onClick={() => setTargetOpen(false)}>auswahl schliessen</Button> : null}
            {!targetOpen ? <Button onClick={() => rollerClose()}>beenden</Button> : null}
        </DialogActions>
    </Dialog>
}
